<template>
  <div class="w-100">
    <header-slot>
      <template #content-right>
        <b-button-group v-if="personalType === 'Employee'" class="mr-2">
          <b-button
            variant="outline-primary"
            @click="showTrabajoAdicionalModal = true"
          >
            Registrar Trabajo Adicional
          </b-button>
          <b-button
            variant="outline-primary"
            v-b-tooltip.hover="'Listado de Trabajos Adicionales'"
            @click="showListaTrabajoAdicional = true"
            ><feather-icon icon="ListIcon"
          /></b-button>
        </b-button-group>

        <b-button
          class="mr-2"
          variant="outline-primary"
          @click="openCheckPayrollPayments()"
          v-b-tooltip.hover="{
            title: $t('Check Payroll Payment'),
            delay: { show: 100, hide: 0 },
          }"
        >
          <feather-icon
            icon="DollarSignIcon"
            size="16"
            class="text-primary cursor-pointer"
          />
          {{ $t("Check Payroll Payment") }}
        </b-button>

        <b-button variant="outline-primary" :to="{ name: 'zerg-menu' }">
          <feather-icon icon="CornerUpLeftIcon"></feather-icon>
          {{ $t("Back to Home") }}
        </b-button>
      </template>
    </header-slot>

    <div
      v-if="
        currentUser.personal_type != 'Driver' &&
        currentUser.personal_type != 'Stevedore'
      "
    >
      <div class="my-font">
        <b-row class="w-100">
          <b-col
            xl="4"
            lg="4"
            :md="menuActive == 3 ? 6 : 4"
            sm="12"
            cols="12"
            style="margin-bottom: 15px"
          >
            <div class="container-tab h-100 border-bottom">
              <div
                class="item-tab mr-1"
                :class="{ 'bg-primary h-dark': menuActive == 1 }"
                @click="menuActive = 1"
              >
                {{ $t("customized") | capitalize }}
              </div>
              <div
                class="item-tab mr-1"
                :class="{ 'bg-primary h-dark': menuActive == 2 }"
                @click="changeTab(2)"
              >
                {{ $t("week") | capitalize }}
              </div>
              <div
                class="item-tab"
                :class="{ 'bg-primary h-dark': menuActive == 3 }"
                @click="menuActive = 3"
              >
                {{ $t("Month") }}
              </div>
            </div>
          </b-col>
          <b-col
            xl="4"
            lg="4"
            md="5"
            sm="6"
            cols="12"
            v-if="menuActive == 1 || menuActive == 2"
          >
            <div class="container-options">
              <div class="d-flex" v-if="menuActive == 1">
                <b-form-group :label="$t('From')">
                  <kendo-datepicker
                    class="w-100 rounded form-control-kendo"
                    :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                    v-model="dateFrom"
                    :format="'dd/MM/yyyy'"
                  ></kendo-datepicker>
                </b-form-group>
                <b-form-group :label="$t('To')">
                  <kendo-datepicker
                    class="w-100 rounded form-control-kendo"
                    style="margin-left: 2px"
                    :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                    v-model="dateTo"
                    :format="'dd/MM/yyyy'"
                  ></kendo-datepicker>
                </b-form-group>
              </div>

              <div
                class="ml-1 border bg-light-secondary p-1 container-week mb-1"
                v-if="menuActive == 2"
              >
                <div class="d-flex align-items-center mr-1">
                  <div class="mr-1 font-weight-bolder">
                    {{ $t("week") | capitalize }}
                  </div>
                  {{ dateFrom | myGlobal }} - {{ dateTo | myGlobal }}
                </div>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="30"
                  class="cursor-pointer rounded-icon text-light"
                  v-b-tooltip.hover
                  :title="$t('previous week') | capitalize"
                  @click="previousWeek"
                ></feather-icon>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="30"
                  class="cursor-pointer rounded-icon text-light"
                  v-b-tooltip.hover
                  :title="$t('next week') | capitalize"
                  @click="nextWeek"
                ></feather-icon>
              </div>
            </div>
          </b-col>
          <b-col
            :class="menuActive == 3 ? 'container-total2' : ''"
            :xl="menuActive == 3 ? 8 : 4"
            :lg="menuActive == 3 ? 8 : 4"
            :md="menuActive == 3 ? 6 : 3"
            :sm="menuActive == 3 ? 12 : 6"
          >
            <div class="border border bg-light-secondary p-1 container-total">
              <div class="text-center">
                <div>{{ $t("goals days") | capitalize }}</div>
                <div class="item-total">{{ totalWorkingDays }}</div>
              </div>
              <div class="item-total" style="margin-top: 3px">-</div>
              <div class="text-center">
                <div>{{ $t("days worked") | capitalize }}</div>
                <div class="item-total">{{ daysWorked }}</div>
              </div>
              <div class="item-total" style="margin-top: 3px">=</div>
              <div class="text-center">
                <div>{{ $t("missing days") | capitalize }}</div>
                <div class="item-total">{{ missingDays }}</div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-row class="mt-2">
        <b-col cols="12">
          <MyAttendanceTable
            v-if="menuActive == 1 || menuActive == 2"
            :attendances="attendances"
          ></MyAttendanceTable>
          <CalendarEmployee
            v-if="menuActive == 3"
            @update="getTotalDaysWorking"
          ></CalendarEmployee>
        </b-col>
      </b-row>
    </div>

    <div v-else>
      <b-row>
        <b-col md="6" class="mt-1">
          <Calendar />
        </b-col>
        <b-col md="6" class="mt-1">
          <card-viatic />
        </b-col>
      </b-row>
    </div>

    <CheckPayrollPaymentModal
      v-if="showCheckPayrollPayments"
      :employeeId="currentUser.employee_id"
      @close="showCheckPayrollPayments = false"
    />

    <TrabajoAdicionalModal
      v-if="showTrabajoAdicionalModal"
      @close="showTrabajoAdicionalModal = false"
    />

    <TrabajoAdicionalListadoModal
      v-if="showListaTrabajoAdicional"
      @close="showListaTrabajoAdicional = false"
    />
  </div>
</template>

<script>
import MyAttendanceTable from "@/views/attendance/views/my-attendance/components/MyAttendanceTable.vue";
import Calendar from "@/views/driver/views/dashboard/components/Calendar.vue";
import CardViatic from "@/views/driver/views/dashboard/components/CardViatic.vue";

import CalendarEmployee from "@/views/attendance/views/my-attendance/components/MyAttendanceCalendar.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import AttendanceService from "@/views/attendance/services/attendance.service.js";
import AttendanceUtils from "@/views/attendance/views/my-attendance/utils/utils.js";
import CheckPayrollPaymentModal from "@/views/rrhh/views/employees/components/modal/CheckPayrollPayment.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import TrabajoAdicionalModal from "@/views/rrhh/views/trabajo-adicional/components/TrabajoAdicionalModal.vue";
import TrabajoAdicionalListadoModal from "@/views/rrhh/views/trabajo-adicional/components/TrabajoAdicionalListadoModal.vue";

export default {
  name: "MyAttendance",

  components: {
    MyAttendanceTable,
    Calendar,
    CardViatic,
    CalendarEmployee,
    CheckPayrollPaymentModal,
    FeatherIcon,
    TrabajoAdicionalModal,
    TrabajoAdicionalListadoModal,
  },

  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      workingDays: "AttendanceStore/G_WORKING_DAYS",
    }),
    personalType() {
      return this.currentUser.personal_type;
    },
  },
  data() {
    return {
      menuActive: 2,
      currentDate: new Date(),
      attendances: [],
      dateFrom: null,
      dateTo: null,
      weekStatus: null,
      holidays: [],
      totalWorkingDays: 0,
      daysWorked: 0,
      missingDays: 0,
      showCheckPayrollPayments: false,
      showTrabajoAdicionalModal: false,
      showListaTrabajoAdicional: false,
    };
  },

  methods: {
    openCheckPayrollPayments() {
      this.showCheckPayrollPayments = true;
    },
    async getHolidays() {
      if (!this.dateFrom) {
        this.obtenerFechaLunesYSabado();
      }

      const currentMonth = moment(this.dateFrom).format("MM");

      const params = {
        months: [currentMonth]
      };

      const data = await AttendanceService.getHolidays(params);
      this.holidays = data.data;
    },

    async getMyAttendance(type) {
      if (!this.dateFrom || !this.dateTo) {
        this.obtenerFechaLunesYSabado();
      }
      if (type == 1) {
        let newDateFrom = this.dateFrom.split("/");
        this.dateFrom = newDateFrom.reverse().join("-");

        let newDateTo = this.dateTo.split("/");
        this.dateTo = newDateTo.reverse().join("-");
      }

      try {
        this.addPreloader();
        const params = {
          employee_id: this.currentUser.employee_id,
          date_from: this.dateFrom,
          date_to: this.dateTo,
        };
        const data = await AttendanceService.getEmployeeAttendance(params);
        this.attendances = await AttendanceUtils.asingAttendace2Day(
          data.data,
          this.dateFrom,
          this.dateTo,
          this.holidays
        );
        this.getTotalDaysWorking(this.attendances);
      } catch (error) {
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },

    async obtenerFechaLunesYSabado() {
      const fechaActual = new Date();
      const diaSemana = fechaActual.getDay(); // Retorna un número del 0 al 6, donde 0 es domingo.

      // Calcular la diferencia entre el día actual y el lunes
      const diasDiferenciaLunes = diaSemana === 0 ? -6 : 1 - diaSemana;
      const lunesFecha = new Date(fechaActual);
      lunesFecha.setDate(fechaActual.getDate() + diasDiferenciaLunes);

      // Calcular la diferencia entre el día actual y el domingo
      const diasDiferenciaDomingo = diaSemana === 0 ? 0 : 7 - diaSemana;
      const domingoFecha = new Date(fechaActual);
      domingoFecha.setDate(fechaActual.getDate() + diasDiferenciaDomingo);

      this.dateFrom = moment(lunesFecha).format("YYYY-MM-DD");
      this.dateTo = moment(domingoFecha).format("YYYY-MM-DD");
    },

    changeTab(value) {
      if (value == 2) {
        this.obtenerFechaLunesYSabado();
        this.menuActive = value;
        this.getMyAttendance(2);
      }
    },

    nextWeek() {
      const newFrom = new Date(this.dateFrom);
      const newTo = new Date(this.dateTo);
      newFrom.setDate(newFrom.getDate() + 8);
      newTo.setDate(newTo.getDate() + 8);
      this.dateFrom = moment(newFrom).format("YYYY-MM-DD");
      this.dateTo = moment(newTo).format("YYYY-MM-DD");
      this.getMyAttendance(2);
    },

    previousWeek() {
      const newFrom = new Date(this.dateFrom);
      const newTo = new Date(this.dateTo);
      newFrom.setDate(newFrom.getDate() - 6);
      newTo.setDate(newTo.getDate() - 6);
      this.dateFrom = moment(newFrom).format("YYYY-MM-DD");
      this.dateTo = moment(newTo).format("YYYY-MM-DD");
      this.getMyAttendance(2);
    },

    getTotalDaysWorking(days) {
      this.totalWorkingDays = 0;
      this.daysWorked = 0;
      this.missingDays = 0;

      const daysValid = days.filter((element) => {
        return this.workingDays[element.day] == 0;
      });

      this.totalWorkingDays = daysValid.length;

      daysValid.forEach((element) => {
        if (element.start_hour || element.holidays || element.status == 3) {
          this.daysWorked += 1;
        }
      });

      this.missingDays = this.totalWorkingDays - this.daysWorked;
    },
  },

  async created() {
    await this.getHolidays();
    await this.getMyAttendance(2);
  },

  watch: {
    weekStatus(newValue, oldValue) {
      if (newValue != null) {
        dateFrom;
      }
    },

    dateFrom() {
      this.getMyAttendance(1);
    },

    dateTo() {
      this.getMyAttendance(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.dark-layout {
  .item-tab {
    background-color: #2d2d30;
  }
  .item-tab:hover {
    background-color: #075d93;
  }
}

.item-tab:hover {
  background-color: #63b9ee;
  color: white;
}

.h-dark {
  color: white;
}
.my-font {
  font-family: "Roboto";
}

.container-tab {
  display: flex;
  align-items: end;
}
.container-options {
  display: flex;
  justify-content: center;
  align-items: end;
}
.item-tab {
  font-family: "Roboto";
  height: 35px;
  font-size: 13px;
  width: 140px;
  cursor: pointer;
  font-weight: bold;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eaeaeb;
}

.no-margin {
  margin: 0 !important;
}

.rounded-icon {
  background-color: #8f5fe8;
  margin: 0 10px;
  border-radius: 100%;
  padding: 5px;
}

.container-week {
  border-radius: 10px;
  display: flex;
  margin-top: 10px;
}

.container-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
}

.container-total2 {
  display: flex;
  justify-content: end;
}
.item-total {
  font-size: 16px;
  margin-top: 5px;
  font-weight: bolder;
}

@media (max-width: 767px) {
  .container-tab {
    justify-content: center;
  }
  .container-total2 {
    justify-content: center;
  }

  .container-week {
    margin-top: 0;
  }
}
</style>